// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"168":"fba8928f","304":"5abd59fa","513":"dcbc1e6e","880":"97718715"}[chunkId] + ".chunk.css";
};